module.exports = __webpack_public_path__ + "img/nav-match-home-act.bf30ff1c.png";